import HParsonsFeedback from "./hparsonsFeedback";
import BlockBasedGrader from "./blockGrader.js";
import "../../parsons/js/parsons-i18n.en.js";
import "../../parsons/js/parsons-i18n.pt-br.js";

export default class BlockFeedback extends HParsonsFeedback {
    createOutput() {
        // Block based grading output
        this.messageDiv = document.createElement("div");
        this.hparsons.outerDiv.appendChild(this.messageDiv);
    }
    
    customizeUI() {
        this.hparsons.runButton.textContent = "Check Me";
    }

    init() {
        this.checkCount = 0;
        this.solved = false;
        // TODO: not sure what is the best way to do this
        this.grader = new BlockBasedGrader();
        const solutionIndices = this.hparsons.blockAnswer.map(Number);
        this.solution = solutionIndices;
        this.grader.solution = solutionIndices;
        this.answerArea = this.hparsons.hparsonsInput.querySelector('.drop-area');
    }

    // Called when check button clicked (block-based Feedback)
    async runButtonHandler() {
        this.checkCurrentAnswer();
        this.logCurrentAnswer();
        this.renderFeedback();
    }

    async logCurrentAnswer() {
        let act = {
            scheme: "block",
            correct: this.grader.graderState == 'correct' ? "T" : "F",
            answer: this.hparsons.hparsonsInput.getBlockIndices(),
            percent: this.grader.percent
        }
        let logData = {
            event: "hparsonsAnswer",
            div_id: this.hparsons.divid,
            act: JSON.stringify(act),
            answer: JSON.stringify({"blocks": act.answer}),
            percent: this.grader.percent,
            correct: act.correct,
        }
        await this.hparsons.logBookEvent(logData);
    }

    // Used for block-based feedback
    checkCurrentAnswer() {
        if (!this.solved) {
            this.checkCount++;
            this.clearFeedback();
            this.grader.answer = this.hparsons.hparsonsInput.getBlockIndices();
            this.grade = this.grader.grade();
            if (this.grade == "correct") {
                this.hparsons.runButton.disabled = true;
                this.solved = true;
            }
        }
    }

    renderFeedback() {
        this.grade = this.grader.graderState;
        var feedbackArea;
        var answerArea = this.answerArea;
        feedbackArea = this.messageDiv;

        if (this.grade === "correct") {
            answerArea.classList.add("correct");
            feedbackArea.style.display = "";
            feedbackArea.className = "hp_feedback alert alert-info";
            if (this.checkCount > 1) {
                feedbackArea.innerHTML =
                    $.i18n("msg_parson_correct", this.checkCount);
            } else {
                feedbackArea.innerHTML = $.i18n("msg_parson_correct_first_try");
            }
            this.checkCount = 0;
        }

        if (this.grade === "incorrectTooShort") {
            // too little code
            answerArea.classList.add("incorrect");
            feedbackArea.style.display = "";
            feedbackArea.className = "hp_feedback alert alert-danger";
            feedbackArea.innerHTML = $.i18n("msg_parson_too_short");
        }

        if (this.grade === "incorrectMoveBlocks") {
            var answerBlocks = this.answerArea.children;
            var inSolution = [];
            var inSolutionIndexes = [];
            var notInSolution = [];
            for (let i = 0; i < answerBlocks.length; i++) {
                var block = answerBlocks[i];
                var index = this.solution.indexOf(Number(block.dataset.index));
                if (index == -1) {
                    notInSolution.push(block);
                } else {
                    inSolution.push(block);
                    inSolutionIndexes.push(index);
                }
            }
            var lisIndexes = this.grader.inverseLISIndices(inSolutionIndexes);
            for (let i = 0; i < lisIndexes.length; i++) {
                notInSolution.push(inSolution[lisIndexes[i]]);
            }
            answerArea.classList.add("incorrect");
            feedbackArea.style.display = "";
            feedbackArea.className = "alert alert-danger";
            for (let i = 0; i < notInSolution.length; i++) {
                notInSolution[i].classList.add("incorrectPosition");
            }
            feedbackArea.innerHTML = $.i18n("msg_parson_wrong_order");
        }
    }

    // Feedback UI for Block-based Feedback
    clearFeedback() {
        this.answerArea.classList.remove("incorrect", "correct");
        var children = this.answerArea.childNodes;
        for (var i = 0; i < children.length; i++) {
            children[i].classList.remove(
                "correctPosition",
                "incorrectPosition"
            );
        }
        this.messageDiv.style.display = "none";
    }

    reset() {
        if (this.solved) {
            this.checkCount = 0;
            this.hparsons.runButton.disabled = false;
            this.solved = false;
        }
        this.clearFeedback();
    }

}
